import * as React from "react";
import { PanelRightClose, PanelRightOpen, Radio } from "lucide-react";

import DirectoryPanel from "./DirectoryPanel";

const STORAGE_KEY = "fable.comms.directoryRail.collapsed";

/**
 * Persistent right-side rail (≥ xl only). Collapses to a slim gutter that
 * remembers state in localStorage. Anywhere below xl the caller should
 * render `DirectoryDrawer` instead (a modal drawer).
 */
export default function DirectoryRail({ companyId, canPost, onOpenConversation }) {
  const [collapsed, setCollapsed] = React.useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; }
    catch { return false; }
  });

  const toggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, next ? "1" : "0"); } catch {}
      return next;
    });
  };

  if (collapsed) {
    return (
      <aside
        className="hidden xl:flex w-10 shrink-0 border-l border-brand-rule bg-card flex-col items-center py-3"
        data-testid="comms-directory-rail-collapsed"
      >
        <button
          type="button"
          onClick={toggle}
          className="btn-ghost h-8 w-8 !p-0"
          title="Show on-shift"
          aria-label="Expand on-shift directory"
          data-testid="comms-directory-rail-expand"
        >
          <PanelRightOpen size={14} />
        </button>
        <div className="mt-2 rotate-180 [writing-mode:vertical-rl] text-[10.5px] tracking-[0.16em] uppercase text-brand-muted">
          on shift
        </div>
      </aside>
    );
  }

  return (
    <aside
      className="hidden xl:flex w-[320px] shrink-0 border-l border-brand-rule bg-card h-full flex-col"
      data-testid="comms-directory-rail"
    >
      <header className="px-4 py-3 border-b border-brand-rule flex items-center gap-2">
        <Radio size={14} className="text-brand-violet" />
        <div className="min-w-0 flex-1">
          <div className="text-[10.5px] uppercase tracking-wider text-brand-muted">Live ops radar</div>
          <div className="text-[13.5px] font-semibold text-brand-ink">On shift now</div>
        </div>
        <button
          type="button"
          onClick={toggle}
          className="btn-ghost h-7 w-7 !p-0"
          title="Hide"
          aria-label="Collapse on-shift directory"
          data-testid="comms-directory-rail-collapse"
        >
          <PanelRightClose size={13} />
        </button>
      </header>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <DirectoryPanel
          companyId={companyId}
          canPost={canPost}
          onOpenConversation={onOpenConversation}
          testidPrefix="directory-rail"
        />
      </div>
    </aside>
  );
}
